import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import WhyHostBlock1 from './WhyHostBlock1';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/jsonMessages';

export default async function action({ store, intl }) {
    const title = intl?.formatMessage(messages.WhyBecomeOwnerBlock1);
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/whyHost/Block1', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><WhyHostBlock1 title={title} /></AdminLayout>,
    };
};
